import { AccountDetailsWithCopyButton } from "../AccountDetailsWithCopyButton";
import { IDedicatedTopUpAccountsViewProps } from "./DedicatedTopUpAccounts";

export const View = (props: IDedicatedTopUpAccountsViewProps) => {
  return !props.merchantTopUpAccounts.length ? null : (
    <div className="top-up-accounts-container col flex-container align-items--end">
      <div className="description">
        <span className="font-ctm--bold text-teal">
          Transfer to the following bank account(s) to top-up your{" "}
          <span className="text-danger">{props.activeBalanceCurrency}</span>{" "}
          wallet:
        </span>
      </div>

      <AccountDetailsWithCopyButton
        accounts_list={props.merchantTopUpAccounts}
      />
    </div>
  );
};
